import React from 'react'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Symbols, TypeAbc, Zodiac} from '../../icons'

const EngravingOptions = (props) => {
    const {
        selectedHeading,
        setSelectedHeading,
        setVisibleLine,
        setDisplayIconType,
        setShowFonts,
        isMonogram,
        selectedZodiacIcons
    } = props
    return (
        <Box>
            <Box display="flex" marginTop="20px" gap="20px" justifyContent="space-between">
                {/** 3 main possible option to engrave **/}
                <Box
                    display="inline-flex"
                    height="fit-content"
                    gap="10px"
                    cursor="pointer"
                    borderBottom={selectedHeading === 'type' ? '1px solid' : '0'}
                    borderColor="teal.500"
                    zIndex="100"
                    paddingBottom="10px"
                    paddingTop="10px"
                    width="100%"
                    onClick={() => {
                        setSelectedHeading('type')
                        setVisibleLine('line1')
                        setDisplayIconType('')
                        setShowFonts(true)
                    }}
                >
                    <Box
                        width="51px"
                        height="30px"
                        textAlign="center"
                        borderRadius="5px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        backgroundColor={selectedHeading === 'type' ? 'black.300' : 'gray.50'}
                    >
                        <TypeAbc
                            width="23px"
                            height="23px"
                            color={selectedHeading === 'type' ? 'white' : 'black.100'}
                        />
                    </Box>
                    <Text
                        alignContent="center"
                        fontSize="13px"
                        fontWeight="500"
                        color={selectedHeading === 'type' ? 'teal.500' : 'black.300'}
                        letterSpacing="0.065px"
                        fontFamily="caslon"
                    >
                        <FormattedMessage id="type" defaultMessage="Type" />
                    </Text>
                </Box>
                <Box
                    display="inline-flex"
                    height="fit-content"
                    gap="10px"
                    width="100%"
                    cursor={'pointer'}
                    pointerEvents={isMonogram ? 'none' : 'unset'}
                    borderBottom={selectedHeading === 'symbols' ? '1px solid' : '0'}
                    borderColor="teal.500"
                    zIndex="100"
                    paddingBottom="10px"
                    paddingTop="10px"
                    onClick={() => {
                        setSelectedHeading('symbols')
                        setVisibleLine('line1')
                        setDisplayIconType('ks')
                        setShowFonts(false)
                    }}
                >
                    <Box
                        width="51px"
                        height="30px"
                        textAlign="center"
                        borderRadius="5px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        backgroundColor={selectedHeading === 'symbols' ? 'black.300' : 'gray.50'}
                    >
                        <Symbols
                            width="18px"
                            height="18px"
                            color={selectedHeading === 'symbols' ? 'white' : 'black.100'}
                        />
                    </Box>
                    <Text
                        alignContent="center"
                        fontSize="13px"
                        fontWeight="500"
                        color={selectedHeading === 'symbols' ? 'teal.500' : 'black.300'}
                        letterSpacing="0.065px"
                        fontFamily="caslon"
                    >
                        <FormattedMessage id="symbols" defaultMessage="Symbols" />
                    </Text>
                </Box>
                {selectedZodiacIcons?.length ? (
                    <Box
                        display="inline-flex"
                        height="fit-content"
                        gap="10px"
                        width="100%"
                        pointerEvents={isMonogram ? 'none' : 'unset'}
                        cursor="pointer"
                        borderBottom={selectedHeading === 'zodiac' ? '1px solid' : '0'}
                        borderColor="teal.500"
                        zIndex="100"
                        paddingBottom="10px"
                        paddingTop="10px"
                        onClick={() => {
                            setSelectedHeading('zodiac')
                            setVisibleLine('line1')
                            setDisplayIconType('zodiac')
                            setShowFonts(false)
                        }}
                    >
                        <Box
                            width="51px"
                            height="30px"
                            textAlign="center"
                            borderRadius="5px"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            backgroundColor={selectedHeading === 'zodiac' ? 'black.300' : 'gray.50'}
                        >
                            <Zodiac
                                width="17px"
                                height="17px"
                                color={selectedHeading === 'zodiac' ? 'white' : 'black.100'}
                            />
                        </Box>
                        <Text
                            alignContent="center"
                            fontSize="13px"
                            fontWeight="500"
                            color={selectedHeading === 'zodiac' ? 'teal.500' : 'black.300'}
                            letterSpacing="0.065px"
                            fontFamily="caslon"
                        >
                            <FormattedMessage id="zodiac.symbols" defaultMessage="Zodiac Signs" />
                        </Text>
                    </Box>
                ) : (
                    <></>
                )}
            </Box>
        </Box>
    )
}

EngravingOptions.propTypes = {
    selectedHeading: PropTypes.string,
    setSelectedHeading: PropTypes.func,
    setVisibleLine: PropTypes.func,
    setDisplayIconType: PropTypes.func,
    setShowFonts: PropTypes.func,
    isMonogram: PropTypes.bool,
    selectedZodiacIcons: PropTypes.arrayOf(PropTypes.string)
}

export default EngravingOptions
